module.exports = __webpack_public_path__ + "static/media/prof.ad4fd2f5.PNG";